if (!customElements.get('arc-product-help')) {
  customElements.define('arc-product-help', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-help-body]');
      this.cache = new Map();
      this.addEventListener('click', (event) => {
        const close = event.target.closest('[data-help-close]');
        if (close) { this.dialog.close(); return; }
        const link = event.target.closest('a');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || link.hasAttribute('data-help-fallback')) return;
        if (!link.hasAttribute('data-help-popup') && !link.closest('[data-help-body]')) return;
        if (!/\/pages\//.test(url.pathname)) return;
        event.preventDefault();
        this.openPage(url, link.textContent.trim(), link, link.hasAttribute('data-help-returns'));
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.request?.abort();
        document.documentElement.classList.remove('arc-info-open');
        this.trigger?.focus({preventScroll:true});
      });
    }
    async openPage(url, title, trigger, showReturns = false) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      if (!this.dialog.open) this.trigger = trigger;
      this.querySelector('[data-help-title]').textContent = title.replace(/\*$/, '');
      this.querySelector('[data-help-shipping]').hidden = !url.pathname.endsWith('/toimitukset');
      this.querySelector('[data-help-error]').hidden = true;
      this.body.textContent = this.dataset.loading;
      this.body.setAttribute('aria-busy', 'true');
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('arc-info-open');
      this.querySelector('.arc-info-dialog__scroll').scrollTop = 0;
      try {
        if (showReturns) {
          this.body.replaceChildren(this.querySelector('template[data-help-returns-content]').content.cloneNode(true));
          return;
        }
        let html = this.cache.get(url.pathname);
        if (!html) {
          const response = await fetch(url.pathname, {signal:request.signal});
          if (!response.ok) throw new Error('Page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          let content = doc.querySelector('.arc-help__inner');
          if (!content) {
            const main = doc.querySelector('main');
            const textBlocks = main?.querySelectorAll('rte-formatter');
            content = main;
            if (textBlocks?.length) {
              content = doc.createElement('div');
              content.innerHTML = Array.from(textBlocks).filter(node => !node.parentElement.closest('rte-formatter')).map(node => node.innerHTML).join('');
            }
          }
          if (!content) throw new Error('Content unavailable');
          content.querySelectorAll('script,style,nav,header,footer,h1').forEach(node => node.remove());
          if (!content.textContent.trim()) throw new Error('Empty content');
          html = content.innerHTML;
          this.cache.set(url.pathname, html);
        }
        if (request.signal.aborted) return;
        this.body.innerHTML = html;
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.body.textContent = '';
        this.querySelector('[data-help-error]').hidden = false;
        this.querySelector('[data-help-fallback]').href = url.href;
      } finally {
        if (!request.signal.aborted) this.body.removeAttribute('aria-busy');
      }
    }
  });
}
